import React from "react";
import _ from "underscore";
import ScratchpadList from "./ScratchpadList";
import LayerComponent, { TLayerProps } from "../lib/LayerComponent";
import { Scratchpad, ScratchpadObject } from "../models/Scratchpad";
import Popover from "./Popover";
import Language from "../lib/Language";

type TPinboardButtonProps = {
    scratchpad: Scratchpad;
    showExtraInfo: boolean;
    /** The type the list beside the button is searching, if it has one. */
    selectedType?: number;
    onObjectSelected?: (object: ScratchpadObject) => void;
} & TLayerProps;

class PinboardButton extends React.Component<TPinboardButtonProps> {
    /** The button the popover points at. */
    _sourceButton = React.createRef<HTMLButtonElement>();

    componentDidMount() {
        this.props.setLayerContentProvider(this.getLayerContent);
        this.props.setLayerCloseHandler(this.onLayerClose);
    }

    componentDidUpdate() {
        if (this.props.isLayerShown) {
            this.props.forceLayerUpdate();
        }
    }

    getLayerContent = () => {
        const offset = _.nodeOffset(this._sourceButton.current);
        const target = {
            top: offset.top,
            left: offset.left,
            width: 32,
            height: 32,
        };
        return (
            <Popover
                target={target}
                style={{ width: Popover.DEFAULT_WIDTH }}
                onClose={this.onLayerClose}
            >
                <ScratchpadList
                    showExtraInfo={this.props.showExtraInfo}
                    objects={this.props.scratchpad.getObjects()}
                    onObjectSelected={this.props.onObjectSelected || _.noop}
                    allowMultiSelection={false}
                    selectedType={this.props.selectedType}
                    hidePlusButton={true}
                />
            </Popover>
        );
    };

    onLayerClose = () => {};

    render() {
        return (
            <>
                <button
                    ref={this._sourceButton}
                    title={Language.get("nc_pinboard")}
                    onClick={this.props.toggleLayer}
                    className="deprecated pinboardToggleButton"
                ></button>
            </>
        );
    }
}

export default LayerComponent.wrap(PinboardButton);
